import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
// import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: []
})
export class LoginComponent implements OnInit {
  form!: FormGroup;
  loading = false;
  submitted = false;

  constructor(private formBuilder: FormBuilder,
    private router: Router) {

  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      username: ['', Validators.required],
      password: ['', Validators.required]
    });
  }

  get f() { return this.form.controls; }

  onSubmit() {
    this.submitted = true;
    if (this.form.valid && this.form.controls.username.value == 'admin' && this.form.controls.password.value == 'admin') {
      this.router.navigate(['/model-maintenance']);
      // this.authService.login(this.form.value)
      //   .subscribe((data: any) => {
      //     if(!data['userExists']){
      //       this.form.get('username')?.setErrors({ invalid: 'Invalid Credentials' });
      //     }
      //   });
    } else {
      this.form.get('username')?.setErrors({ invalid: 'Invalid Credentials' });
    }
  }
}
